import script from "./search-input.vue?vue&type=script&setup=true&lang=ts"
export * from "./search-input.vue?vue&type=script&setup=true&lang=ts"

import "./search-input.vue?vue&type=style&index=0&id=f89ae26e&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f89ae26e"]])

export default __exports__